<template>
  <div class="content">
    <div class="toptit">
      <span>核心优势</span>
      <img src="../../assets/home-hexinyoushi/advantage.png" alt="" />
    </div>
    <div class="box">
       <div class="hx-eve" v-for="item in datalist" :key="item.num">
           <img :src="item.url" alt="">
           <span>{{ item.title }}</span>
       </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datalist:[
        {
          url:require("../../assets/home-hexinyoushi/icon1.png"),
          title:"国家专利",
          num:1
        },
        {
          url:require("../../assets/home-hexinyoushi/icon2.png"),
          title:"基于ARM",
          num:2
        },
        {
          url:require("../../assets/home-hexinyoushi/icon3.png"),
          title:"云端存储",
          num:3
        },
        {
          url:require("../../assets/home-hexinyoushi/icon4.png"),
          title:"多平台链接",
          num:4
        },
        {
          url:require("../../assets/home-hexinyoushi/icon5.png"),
          title:"脱机运行",
          num:5
        },
        {
          url:require("../../assets/home-hexinyoushi/icon6.png"),
          title:"效能分析",
          num:6
        },
        {
          url:require("../../assets/home-hexinyoushi/icon7.png"),
          title:"安全可靠",
          num:7
        },
        {
          url:require("../../assets/home-hexinyoushi/icon8.png"),
          title:"应用广泛",
          num:8
        }
      ]
    };
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 500px;
  // border: 1px solid red;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .toptit {
    display: flex;
    flex-direction: column;
    margin-right: 500px;
    span {
      font-size: 40px;
      font-family: NotoSansHans-Regular, NotoSansHans;
      font-weight: 400;
      color: #333333;
    }
    img {
      width: 699px;
      height: 66px;
      margin-top: -20px;
    }
  }
  .box {
    width: 70%;
    // height: 280px;
    // border: 1px solid blue;
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .hx-eve {
      width: 24%;
      height: 132px;
      border: 1px solid #EAEAEA;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin-left: 15px;
      }
    }
  }
}
</style>